export const allLinks = {
  UserManager: {
    links: [
      { title: 'لیست کاربران', url: 'AllUsers' },
      { title: 'ایجاد گروه', url: 'CreateGroup' },
      { title: 'ایجاد کاربر', url: 'CreateUser' },
      { title: 'لیست گروه ها', url: 'AllGroups' },
    ],
    type: 1,
  },
  WeatherStation: {
    links: [
      { title: 'لیست ایستگاه های هواشناسی', url: 'List' },
      { title: 'آپلود اطلاعات', url: 'Upload' },
      { title: 'افزودن اطلاعات', url: 'Add' },
      { title: 'دریافت اطلاعات هر ایستگاه', url: 'Get' },
    ],
    type: 1,
  },
  Synoptic: {
    links: [
      { title: 'لیست ایستگاه های سینوپتیک', url: 'List' },
      { title: 'آپلود اطلاعات', url: 'Upload' },
      { title: 'افزودن اطلاعات', url: 'Add' },
      { title: 'دریافت اطلاعات هر ایستگاه', url: 'Get' },
    ],
    type: 1,
  },
  Hydrometric: {
    links: [
      { title: 'لیست ایستگاه های هیدرومتریک', url: 'List' },
      { title: 'آپلود اطلاعات', url: 'Upload' },
      { title: 'افزودن اطلاعات', url: 'Add' },
      { title: 'دریافت اطلاعات هر ایستگاه', url: 'Get' },
    ],
    type: 1,
  },
  Aquifer: {
    links: [
      { title: 'لیست آبخوان ها', url: 'List' },
      { title: 'آپلود اطلاعات', url: 'Upload' },
      { title: 'افزودن اطلاعات', url: 'Add' },
      { title: 'دریافت اطلاعات', url: 'Get' },
    ],
    type: 1,
  },
  Lake: {
    links: [
      { title: 'لیست دریاچه', url: 'List' },
      { title: 'آپلود اطلاعات', url: 'Upload' },
      { title: 'افزودن اطلاعات', url: 'Add' },
      { title: 'دریافت اطلاعات', url: 'Get' },
    ],
    options: [
      { fa: 'تراز', en: 'level' },
      { fa: 'تبخیر', en: 'evaporation' },
    ],
    type: 2,
  },
  Watershed: {
    links: [
      { title: 'لیست آبریز', url: 'List' },
      { title: 'آپلود اطلاعات', url: 'Upload' },
      { title: 'افزودن اطلاعات', url: 'Add' },
      { title: 'دریافت اطلاعات', url: 'Get' },
    ],
    options: [
      { fa: 'بارش', en: 'rainfall' },
      { fa: 'تبخیر', en: 'evaporation' },
    ],
    type: 2,
  },
};
